import styles from './styles.module.scss';
import { Modal } from 'components-antd';
import { ModalProps } from 'components-antd';
import { Spinner, Avatar } from 'components';
import { CloseModalIconSmall } from 'pages/ServicesCategory/components/AddVendorModal/icons';
import moment from 'moment';
import { Table } from 'components-antd';
import classNames from 'classnames';
import { convertNameToAvatarPlaceholder } from 'helpers';

export interface FilesModalPropsType extends ModalProps {
  loading: boolean;
  loadingPreview: boolean;
  handleClose: () => void;
  files: any[];
  handleFileViewClick: (row) => void;
}

const FilesModal = (props: FilesModalPropsType) => {
  const { open, handleClose, loading, files, handleFileViewClick, loadingPreview } = props;

  const handleModalClose = () => {
    handleClose();
  };

  const getFileIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
        stroke="#515151"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
        stroke="#515151"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9H10"
        stroke="#515151"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 13H15"
        stroke="#515151"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 17H15"
        stroke="#515151"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const columns: any[] = [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'Title',
      width: 500,
      sorter: (a, b) => {
        if (a.Title < b.Title) return -1;
        if (a.Title > b.Title) return 1;
        return 0;
      },
      render: (_, row) => {
        return (
          <div className={styles.fileTitleContainer}>
            <div className={styles.icon}>{getFileIcon()}</div>
            <div className={styles.info}>
              <div className={styles.infoTitle}>{row.Title}</div>
              {row?.PropertyAddress?.Line1 && (
                <div className={styles.infoSubTitle}>{row.PropertyAddress.Line1}</div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: 'Owner',
      key: 'owner',
      dataIndex: 'UploaderFirstName',
      width: 170,
      sorter: (a, b) => {
        if (a.UploaderFirstName < b.UploaderFirstName) return -1;
        if (a.UploaderFirstName > b.UploaderFirstName) return 1;
        return 0;
      },
      render: (_, row) => {
        return (
          <div className={styles.fileUploader}>
            <Avatar
              className={styles.avatarWrap}
              avatarClassName={styles.avatar}
              src={row.UploaderAvatarUrl}
              placeholder={convertNameToAvatarPlaceholder(
                `${row.UploaderFirstName}${row.UploaderLastName ? ` ${row.UploaderLastName}` : ''}`,
              )}
            />
            <div className={styles.name}>{`${row.UploaderFirstName}${
              row.UploaderLastName ? ` ${row.UploaderLastName}` : ''
            }`}</div>
          </div>
        );
      },
    },
    {
      title: 'Created',
      key: 'created',
      dataIndex: 'CreatedDate',
      width: 148,
      sorter: (a, b) => moment(a.CreatedDate).unix() - moment(b.CreatedDate).unix(),
      render: (_, { CreatedDate }) => {
        const localMoment = moment.utc(CreatedDate).local();
        const formattedDate = localMoment.format('MM/DD/YYYY');
        const formattedTime = localMoment.format('h:mm A');

        return (
          <div className={styles.fileDate}>
            <div className={styles.date}>{formattedDate}</div>
            <div className={styles.time}>{formattedTime}</div>
          </div>
        );
      },
    },
    {
      title: '',
      key: 'view',
      width: 150,
      render: (_, row) => {
        return (
          <div className={styles.fileView}>
            <div className={styles.fileViewButton} onClick={() => handleFileViewClick(row)}>
              View
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <Modal
      className={styles.filesModal}
      footer={null}
      width={1002}
      open={open}
      onCancel={handleModalClose}
      destroyOnClose
      closable={true}
      zIndex={1000}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <div></div>
          <div>New Files</div>
          <div className={styles.close} onClick={handleModalClose}>
            <CloseModalIconSmall />
          </div>
        </div>
        {loading ? (
          <div className={classNames(styles.filesTable, styles.otherStates)}>
            <Spinner />
          </div>
        ) : files.length ? (
          <div className={styles.filesTableContainer}>
            <Table
              className={styles.filesTable}
              loading={loading || loadingPreview}
              bordered={false}
              columns={columns}
              dataSource={files.map((item, key) => ({ ...item, key }))}
              pagination={false}
            />
          </div>
        ) : (
          <div className={classNames(styles.filesTable, styles.otherStates)}>No Files.</div>
        )}
      </div>
    </Modal>
  );
};

export default FilesModal;
